import React from 'react';
import styled from 'styled-components';

import KakaoNotificationBox from './KakaoNotificationBox';
import ExpiredPushNotificationBox from './ExpiredPushNotificationBox';

export default function AutoNotificationBox(props) {
  const {
    onRequireCard,
    expired,
    setExpired,
    isDuplicatePushLimited,
    onClickDuplicatePush,
    isDuplicateKakaoLimited,
    onClickDuplicateKakao,
    onClickEdit
  } = props;

  return (
    <MessageBoxWrapper>
      <DivisionSettingBoxWrapper>
        <KakaoNotificationBox
          onRequireCard={onRequireCard}
          isUseDuplicateLimit={isDuplicateKakaoLimited}
          onClickDuplicateLimit={onClickDuplicateKakao} />
        <ExpiredPushNotificationBox
          expired={expired}
          setExpired={setExpired}
          isUseDuplicateLimit={isDuplicatePushLimited}
          onClickDuplicateLimit={onClickDuplicatePush}
          onClickEdit={onClickEdit} />
      </DivisionSettingBoxWrapper>
    </MessageBoxWrapper>
  );
}

const MessageBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 16px;

  width: 1035px;
`;

const DivisionSettingBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 40px;

  width: 100%;

  gap: 30px;
`;
